import React, { useState } from "react";
import Table from "react-bootstrap/Table";
import CopyAllIcon from "@mui/icons-material/CopyAll";
import { useSelector } from 'react-redux';

function SalesChannel({ showToast }) {
  const salesChannelInfo = useSelector(state=>state.salesChannel.optionsData);

  const triggerToast = (isSuccess) => {
    showToast("");

    setTimeout(() => {
      showToast(isSuccess ? "successCopyClipboard" : "failedCopyClipboard");
    }, 100);
  };

  const copyToClipboard = async (text) => {
    const textStr = String(text);

    // Modern API (Requires HTTPS
    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(textStr);
        triggerToast(true);
        return;
      } catch (err) {
        console.error("Modern clipboard failed, trying fallback...", err);
      }
    }

    // Fallback (Works on HTTP & Older Browsers)
    try {
      const textArea = document.createElement("textarea");
      textArea.value = textStr;

      // Make it invisible but part of the DOM
      textArea.style.position = "fixed";
      textArea.style.left = "-9999px";
      textArea.style.top = "0";
      document.body.appendChild(textArea);

      textArea.focus();
      textArea.select();

      const successful = document.execCommand("copy");
      document.body.removeChild(textArea);

      if (successful) {
        triggerToast(true);
      } else {
        throw new Error("Fallback copy failed");
      }
    } catch (err) {
      console.error("All copy methods failed", err);
      triggerToast(false);
    }
  };

  return (
    <>
      <h6 className="fw-bold mt-3 mb-3 p-1 fs-14">Sales Channels</h6>
      <div className="table-wrapper">
      <Table className="mb-0">
        <thead>
          <tr>
            <th className="ps-3 fs-14">Channel Name</th>
            <th className="ps-3 fs-14">Channel ID</th>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(salesChannelInfo)  && salesChannelInfo?.map((value,index)=>{
            return (<tr key={index}>
              <td className="ps-3 fs-14">{value.name}</td>
              <td className="ps-3 fs-14">
                {value.id.replace("gid://shopify/Publication/","")}
                <button
                  type="button"
                  style={{ border: "none", backgroundColor: "#fff" }}
                  onClick={() => copyToClipboard(value.id.replace("gid://shopify/Publication/",""))}
                >
                  <CopyAllIcon style={{ cursor: "pointer" }} />
                </button>
              </td>
              </tr>)
          })}
        </tbody>
      </Table>
      </div>
    </>
  );
}

export default SalesChannel;
